import { AbstractUser } from '@/model/data-object/AbstractUser'

export class PubUser extends AbstractUser {}
